import {ContainerWelcome } from "./styles";
import bg2version from '../../assets/bg2version.jpg';

export function Welcome() {
    return(
        <ContainerWelcome>
            <img className="bg" src={bg2version} alt="gray background with a white design" />
            <div className="content">
                <h1>Inspired by</h1>
                <div>
                    <p>
                        The metaverse is a cosmos that exists within the realm of what we know–but on a digital, parallel universe. The idea that our world can expand infinitely inward or outward is what inspired the construction of Fractalia, a space in Decentraland where worlds collide. 
                    </p>
                    <p>
                        We partnered with the team that made the <strong>7th season of Game of Thrones</strong> a reality and now we want you to visit us, experience our space, unlock the secrets, and join the community.
                    </p>
                </div>
            </div>
        </ContainerWelcome>
    )
}